<template>
  <div>
    <v-select
      v-if="useVuetify"
      v-model="selectedId"
      @update:model-value="do_change"
      :label="label"
      :placeholder="placeholder"
      :items="selectOptions"
      :density="vuetifyDensity"
      :error="error"
      :error-messages="errorMessages"
      hide-details="auto"
      variant="outlined"
      clearable
    ></v-select>
    <el-select
      v-else
      v-model="selectedId"
      @change="do_change"
      :placeholder="placeholder"
      :size="size"
    >
      <el-option v-if="allowAll" :value="0" :label="'Any Reason'"></el-option>
      <el-option v-for="option in filteredLostReasons"
        :value="option.id"
        :key="option.id"
        :label="option.label"
        :disabled="option?.is_active == false ? true : false"
      >
        <!-- TODO add label color -->
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'lostReasonSelect',
  computed: {
    ...mapGetters('lostReason', ['getLostReasons']),
    filteredLostReasons() {
      return this.getLostReasons.filter(
        (r) => this.leadStatusId && r.lead_status_id ? r.lead_status_id == this.leadStatusId : true
      );
    },
    selectOptions() {
      const options = this.getLostReasons.filter(
        (r) => r.lead_status_id ? r.lead_status_id == this.leadStatusId : true
      ).map((reason) => ({
        value: reason.id,
        title: reason.label,
        props: {
          disabled: reason?.is_active == false ? true : false,
        },
      }));

      if (this.allowAll) {
        options.unshift({ value: 0, title: 'Any Reason' });
      }

      return options;
    },
    vuetifyDensity() {
      const densityMap = {
        default: 'default',
        small: 'compact',
        mini: 'comfortable',
      };
      return densityMap[this.size] || 'compact';
    },
  },
  props: {
    // Add v-model support
    value: { type: [Number, String],
    },
    initialId: {
      type: Number,
      required: false,
    },
    leadStatusId: {
      type: Number,
      required: false,
    },
    size: {
      type: String,
      default: () => {
        return 'small';
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: () => {
        return 'Select a Lost Reason';
      },
    },
    allowAll: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: () => {
        return 'Lost Reason';
      },
    },
    error: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedId: undefined,
    };
  },
  watch: {
    initialId(id) {
      this.selectedId = id;
    },
    value(n) {
      this.selectedId = parseInt(n);
    },
  },
  async created() {
    if (!this.getLostReasons || this.getLostReasons.length == 0) {
      await this.fetchLostReasons();
    }
    if (this.value != undefined) {
      this.selectedId = parseInt(this.value);
    }
    if (this.initialId) {
      this.selectedId = this.initialId;
    }
  },
  methods: {
    ...mapActions('lostReason', ['fetchLostReasons']),
    do_change() {
      const lostReason = this.getLostReasons.find(
        (s) => s.id == this.selectedId
      );
      this.$emit('update:lostReason', lostReason);
      if (lostReason) {
        this.$emit('update:modelValue', lostReason.id);
        this.$emit('change', lostReason.id);
      } else {
        // Because we parse from a string at times 0 instead of undefined
        this.$emit('update:modelValue', 0);
        this.$emit('change', 0);
      }
    },
  },
};
</script>
